<script>
import ColorPicker from "./ColorPicker.vue";
import SelectDropdown from "./SelectDropdown.vue";
import { fontList, fontSizeList } from "../utils/staticData";

export default {
    name: "StyleBox",
    components: {
        ColorPicker,
        SelectDropdown,
    },
    props: {
        styling: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            searchQuery: "",
            fontList,
            fontSizeList,
        };
    },
    methods: {
        onColorChange(value) {
            this.styling.color = value;
        },
        handleFontSizeSelection(value) {
            this.styling.size = value;
        },
        handleFontSelection(value) {
            this.styling.font = value;
        },
    },
};
</script>


<template>
  <div class="d-flex flex-column">
    <label v-if="label" class="label">{{ label }}</label>
    <div class="font-style-grid">
      <ColorPicker :modelValue="styling.color" @change="onColorChange" :disabled="disabled" />

      <SelectDropdown :modelValue="styling.font" :options="fontList" placeholder="Font Family"
        @update:modelValue="handleFontSelection" :disabled="disabled" :isFontFamily="true" :showSearch="true"
        :searchQuery.sync="searchQuery" />
      <div class="d-flex">
        <SelectDropdown :modelValue="styling.size" :options="fontSizeList" placeholder="Size"
          @update:modelValue="handleFontSizeSelection" :disabled="disabled" />
        <div class="d-flex align-items-center ml-1">
          <button :class="`style-btn ${styling.bold && 'active'}`" @click="styling.bold = !styling.bold"
            :disabled="disabled">
            B
          </button>
          <button :class="`style-btn ${styling.italic && 'active'}`" @click="styling.italic = !styling.italic"
            :disabled="disabled">
            I
          </button>
          <button :class="`style-btn ${styling.underline && 'active'}`" @click="styling.underline = !styling.underline"
            :disabled="disabled">
            U
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.label {
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 4px;
}

.font-style-grid {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.style-btn {
  width: 38px;
  height: 100%;
  background: white;
  color: grey;
  border: 1px solid #ddd;
  transition: all 0.2s;
  border-radius: 5px;

  &:not(:last-child) {
    margin-right: 2px;
  }

  &:hover {
    background: #ddd;
    color: white;
  }

  &.active {
    background: gray;
    color: white;
  }

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>